import { Component, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FulfilmentTypeEnum } from "@enums/fulfilmentType.enum";
import { MaterialShape } from "@enums/materialShape.enum";
import { MaterialType } from "@enums/materialType.enum";
import { PurchaseTypeEnum } from "@enums/purchaseType.enum";
import { environment } from "@environments/environment";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { densityForMaterialType } from "@helpers/materialTypeDensity";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Client } from "@interfaces/models/client.interface";
import { Contract } from "@interfaces/models/contract.interface";
import { Part } from "@interfaces/models/part.interface";
import { PaymentTerm } from "@interfaces/models/paymentTerm.interface";
import { PurchaseLog } from "@interfaces/models/purchaseLog.interface";
import { Supplier } from "@interfaces/models/supplier.interface";
import { Project } from "@interfaces/project.interface";
import { PurchasableItem } from "@interfaces/purchasableItem.interface";
import { PurchaseLogFileLink } from "@interfaces/purchaseLogFileLink.interface";
import { PurchaseLogLineItem } from "@interfaces/purchaseLogLineItem.interface";
import { PurchaseLogLineItemAllocation } from "@interfaces/purchaseLogLineItemAllocation.interface";
import { PurchaseLogWorkOrder } from "@interfaces/purchaseLogWorkOrder.interface";
import { Site } from "@interfaces/site.interface";
import { StockStore } from "@interfaces/stockStore.interface";
import { SupplierContact } from "@interfaces/supplierContact.interface";
import { WorkOrder } from "@interfaces/workOrder.interface";
import { AuthService } from "@services/auth.service";
import { ClientService } from "@services/client.service";
import { ContractService } from "@services/contract.service";
import { FileService } from "@services/file.service";
import { OutsourcedSpecificationService } from "@services/outsourcedSpecification.service";
import { PartService } from "@services/part.service";
import { PaymentTermService } from "@services/paymentTerm.service";
import { ProjectService } from "@services/project.service";
import { PurchasableItemService } from "@services/purchasableItem.service";
import { PurchaseLogService } from "@services/purchaseLog.service";
import { PurchaseLogLineItemAllocationService } from "@services/purchaseLogLineItemAllocation.service";
import { PurchaseLogWorkOrderService } from "@services/purchaseLogWorkOrder.service";
import { SiteService } from "@services/site.service";
import { StockStoreService } from "@services/stockStore.service";
import { SupplierService } from "@services/supplier.service";
import { SupplierContactService } from "@services/supplierContact.service";
import { WorkOrderService } from "@services/workOrder.service";
import { ToastService } from "angular-toastify";
import { DxDataGridComponent, DxFormComponent } from "devextreme-angular";
import { Guid } from "guid-typescript";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "purchaseLogs-id",
	styleUrls: ["purchaseLogs-id.css"],
	templateUrl: "purchaseLogs-id.html"
})
export class PurchaseLogsIdAdminComponent {
	@ViewChild("gridContainer", { static: false }) dataGrid!: DxDataGridComponent;
	@ViewChild("purchaseLogForm", { static: false }) purchaseLogForm!: DxFormComponent;
	addSupportingDocumentButtonOptions = { onClick: () => this.addNewSupportingDocumentPopup(), text: "Add Document", type: "default", useSubmitBehavior: false }
	addWorkOrderButtonOptions = { onClick: () => this.addWorkOrderPopup(), text: "Add Work Order", type: "default", useSubmitBehavior: false }
	changes: any = [];
	clients: Client[] = [];
	contact: SupplierContact = new SupplierContact();
	contacts: SupplierContact[] = [];
	contracts: Contract[] = [];
	createEnabled = true;
	editEnabled = true;
	editRowKey: any = null;
	filteredParts: Part[] = [];
	filteredPurchasableItems: PurchasableItem[] = [];
	fulfilmentTypes: any;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	headerTertiaryButtons: AdminHeaderButton[] = [];
	item: PurchaseLog = new PurchaseLog();
	itemType = "Purchase Log";
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	lineItemAllocations: PurchaseLogLineItemAllocation[] = [];
	lineItems: PurchaseLogLineItem[] = [];
	materialShapes: any;
	materialTypes: any;
	partSelected: Part = new Part;
	parts: Part[] = [];
	partsSpec: Part[] = [];
	paymentTerms: PaymentTerm[] = [];
	popupAddButtonOptions: any;
	popupCloseButtonOptions: any = { onClick: () => this.closePopup(), text: "Close" };
	popupContact: SupplierContact = new SupplierContact();
	popupProject: Project = new Project();
	popupPurchasableItem: PurchasableItem = new PurchasableItem();
	popupPurchaseLogLineItemAllocation: PurchaseLogLineItemAllocation = new PurchaseLogLineItemAllocation();
	popupPurchaseLogWorkOrder: PurchaseLogWorkOrder = new PurchaseLogWorkOrder();
	popupSupplier: Supplier = new Supplier();
	popupSupportingDocument: PurchaseLogFileLink = new PurchaseLogFileLink();
	popupTitle = "";
	popupVisible = false;
	projects: Project[] = [];
	purchasableItems: PurchasableItem[] = [];
	purchasableSpecs: string[] = [];
	purchaseTypes: any;
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	screenMode = "";
	sites: Site[] = [];
	stockStore: StockStore[] = [];
	suppliers: Supplier[] = [];
	supportingDocuments: PurchaseLogFileLink[] = [];
	thicknesses: number[] = environment.build.thicknesses;
	title: string = "View " + this.itemType;
	workOrders: WorkOrder[] = [];
	workOrdersDropDown: WorkOrder[] = [];
	workOrdersDropDownForAllocations: WorkOrder[] = [];

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private authService: AuthService, private clientService: ClientService, private contractService: ContractService, private fileService: FileService, private outsourcedSpecificationService: OutsourcedSpecificationService, private partService: PartService, private paymentTermsService: PaymentTermService, private projectService: ProjectService, private purchasableItemService: PurchasableItemService, private itemService: PurchaseLogService, private purchaseLogLineItemAllocationService: PurchaseLogLineItemAllocationService, private purchaseLogWorkOrderService: PurchaseLogWorkOrderService, private siteService: SiteService, private supplierContactService: SupplierContactService, private supplierService: SupplierService, private stockStoreService: StockStoreService, private workOrderService: WorkOrderService) {
		this.getClients();
		this.getPaymentTerms();
		this.getProjects();
		this.getSites();
		this.getSuppliers();
		this.getWorkOrdersForDropDown();

		this.fulfilmentTypes = GetPropertiesFromEnum(FulfilmentTypeEnum);
		this.materialShapes = GetPropertiesFromEnum(MaterialShape);
		this.materialTypes = GetPropertiesFromEnum(MaterialType);
		this.purchaseTypes = GetPropertiesFromEnum(PurchaseTypeEnum);
		this.route.params.subscribe((params) => {
			if (params.id != "create") {
				if (params.id.split("_").length > 1) {
					this.getItem(params.id.split("_")[0], "edit");
					this.edit();
				} else {
					this.getItem(params.id, "view");
				}
			} else {
				this.create();
				this.buildButtons("create");
			}
		});

		this.cloneIconClick = this.cloneIconClick.bind(this);
		this.createPurchaseLogLineItemAllocationPopup = this.createPurchaseLogLineItemAllocationPopup.bind(this);
		this.deleteLineItemAllocation = this.deleteLineItemAllocation.bind(this);
		this.deleteSupportingDocumentLink = this.deleteSupportingDocumentLink.bind(this);
		this.deleteWorkOrderLink = this.deleteWorkOrderLink.bind(this);
		this.downloadPrice = this.downloadPrice.bind(this);
		this.downloadFileLink = this.downloadFileLink.bind(this);
		this.updateLineNumbers = this.updateLineNumbers.bind(this);
		this.uploadSupportingDocument = this.uploadSupportingDocument.bind(this);
		this.saveLineItemChanges = this.saveLineItemChanges.bind(this);
		this.stockReceivedSingle = this.stockReceivedSingle.bind(this);
		this.viewLineItemAllocationWorkOrder = this.viewLineItemAllocationWorkOrder.bind(this);
		this.viewStoreItem = this.viewStoreItem.bind(this);
		this.viewWorkOrderLink = this.viewWorkOrderLink.bind(this);

		this.onInitNewLineItemRow = this.onInitNewLineItemRow.bind(this);
		this.onSetLineItemDescriptionCellValue = this.onSetLineItemDescriptionCellValue.bind(this);
	}

	addNewContact() {
		this.supplierContactService.createSingle(this.popupContact)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.getContacts(this.item.supplierId, true);
				},
				(err: any) => console.log(err)
			);
	}

	addNewContactPopup() {
		if (this.item.supplierId === undefined || this.item.supplierId === null || this.item.supplierId < 1) {
			alert("No Supplier Selected - Please select a supplier before adding a contact.");
			return;
		}
		this.popupContact = new SupplierContact();
		this.popupContact.supplierId = this.item.supplierId;
		this.popupTitle = "Add New Contact";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewContact(), text: "Add Contact" };
	}

	addNewProject() {
		this.projectService.createSingle(this.popupProject)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.getProjects(true);
				},
				(err: any) => {
					this.toastService.error("Could not add client project. Please check the details are valid and this project does not already exist.");
					console.log(err);
				}
			);
	}

	addNewProjectPopup() {
		this.popupProject = new Project();
		this.popupTitle = "Add New Project";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewProject(), text: "Add Project" };
	}

	addNewPurchasableItem() {
		this.purchasableItemService.createSingle(this.popupPurchasableItem)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.popupPurchasableItem = new PurchasableItem();
					this.getPurchasableItems();
				},
				(err: any) => console.log(err)
			);
	}

	addNewPurchasableItemPopup() {
		this.popupTitle = "Add New Purchasable Item";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewPurchasableItem(), text: "Add Item" };
	}

	addNewSupplier() {
		this.supplierService.createSingle(this.popupSupplier)
			.subscribe(
				() => {
					this.getSuppliers(true);

					this.popupVisible = false;
					this.popupSupplier = new Supplier();
				},
				(err: any) => console.log(err)
			);
	}

	addNewSupplierPopup() {
		this.popupTitle = "Add New Supplier";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewSupplier(), text: "Add Supplier" };
	}

	addNewSupportingDocument() {
		if (this.popupSupportingDocument === null || this.popupSupportingDocument === undefined || this.popupSupportingDocument.fileName === "") {
			alert("Please upload a document");
			return;
		}
		this.supportingDocuments.push(this.popupSupportingDocument);
		this.popupSupportingDocument = new PurchaseLogFileLink();

		if (this.title === "Create New " + this.itemType) {
			this.createItem();
		} else {
			this.updateItem();
		}
		this.closePopup();
	}

	addNewSupportingDocumentPopup() {
		this.popupSupportingDocument = new PurchaseLogFileLink();
		this.popupTitle = "Add New Supporting Document";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewSupportingDocument(), text: "Add Document" };
	}

	addWorkOrder() {
		this.purchaseLogWorkOrderService.createSingle(this.popupPurchaseLogWorkOrder)
			.subscribe(
				() => {
					this.getWorkOrders();
					this.popupVisible = false;
				},
				(err: any) => console.log(err)
			);
	}

	addWorkOrderPopup() {
		this.popupPurchaseLogWorkOrder = new PurchaseLogWorkOrder();
		this.popupPurchaseLogWorkOrder.purchaseLogId = this.item.id;
		this.popupTitle = "Add Work Order";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addWorkOrder(), text: "Add Work Order" };
	}

	buildButtons(mode: string) {
		this.screenMode = mode;

		if (mode == "edit" && this.editEnabled) {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
			this.headerTertiaryButtons = [
				{ method: "addNewPurchasableItemPopup", text: "Add New Item" },
				{ method: "addNewContactPopup", text: "Add New Contact" },
				{ method: "addNewProjectPopup", text: "Add New Project" },
				{ method: "addNewSupplierPopup", text: "Add New Supplier" }
			];
		} else if (mode == "create" && this.createEnabled) {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save" },
				{ method: "close", text: "Close" }
			];
			this.headerTertiaryButtons = [
				{ method: "addNewPurchasableItemPopup", text: "Add New Item" },
				{ method: "addNewContactPopup", text: "Add New Contact" },
				{ method: "addNewProjectPopup", text: "Add New Project" },
				{ method: "addNewSupplierPopup", text: "Add New Supplier" }
			];
		} else if (mode == "view") {
			this.headerPrimaryButtons = [
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" }
			];
			this.headerSecondaryButtons = [
				{ method: "generatePDF", text: "Send PO" },
				{ method: "generatePreviewPDF", text: "Download PDF" },
				{ icon: "fal fa-copy", method: "duplicate", text: "Duplicate" }
			];

			if (this.item.orderReceived === false) {
				this.headerSecondaryButtons.push({ method: "stockReceived", text: "Log Received" });
			}

			this.headerTertiaryButtons = [];
			if (this.item.paid === false) {
				this.headerTertiaryButtons.push({ method: "markPaid", text: "Mark as Paid" });
			}
		}
	}

	cancelEditing() {
		if (confirm("Are you sure you wish to switch modes? Unsaved changes will be discarded.") == false) {
			return;
		}
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
	}

	cloneIconClick(line: any) {
		const data = line.row.data;
		const newLine: PurchaseLogLineItem = new PurchaseLogLineItem;
		newLine.lineDescription = data.lineDescription;
		newLine.width = data.width;
		newLine.length = data.length;
		newLine.thickness = data.thickness;
		newLine.quantity = data.quantity;
		newLine.cost = data.cost;
		newLine.lineCost = newLine.quantity * newLine.cost;
		newLine.lineNumber = this.lineItems.length + 1;
		this.lineItems.push(newLine);
	}

	close() {
		this.router.navigate([`/${this.returnUrl}/`]);
	}

	closePopup() {
		this.popupVisible = false;
	}

	create() {
		this.getEmail();
		this.getParts();
		this.getPurchasableItems();
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createItem() {
		this.updateLineNumbers();
		this.item.lineItems = JSON.stringify(this.lineItems);
		this.item.supportingDocuments = JSON.stringify(this.supportingDocuments);

		this.itemService.createSingle(this.item)
			.subscribe(
				(res: any) => {
					this.toastService.success("Successfully Created " + this.itemType);
					this.router.navigate([`/${this.itemUrl}/${res.response.lookupId}_edit`]);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	createPurchaseLogLineItemAllocation() {
		this.purchaseLogLineItemAllocationService.createSingle(this.popupPurchaseLogLineItemAllocation)
			.subscribe(
				() => {
					this.getItem(this.item.lookupId, this.screenMode);
					this.popupVisible = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	createPurchaseLogLineItemAllocationPopup(e: any) {
		this.popupPurchaseLogLineItemAllocation = new PurchaseLogLineItemAllocation();
		this.popupPurchaseLogLineItemAllocation.purchaseLogId = this.item.id;
		this.popupPurchaseLogLineItemAllocation.lineItemLookupId = e.row.data.lookupId;
		this.popupPurchaseLogLineItemAllocation.lineItemDescription = e.row.data.lineDescription;
		this.getWorkOrdersForAllocationsDropDown(e.row.data.lineDescription);
		this.popupTitle = "Add Allocation";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.createPurchaseLogLineItemAllocation(), text: "Add Allocation" };
	}

	deleteLineItemAllocation(e: any) {
		if (confirm("Are you sure you wish to delete this allocation?") == false) {
			return false;
		}

		this.purchaseLogLineItemAllocationService.deleteSingleById(e.row.data.id)
			.subscribe(
				() => {
					this.getItem(this.item.lookupId, this.screenMode);
					this.popupVisible = false;
				},
				(err: any) => console.log(err)
			);

		return false;
	}

	deleteSupportingDocumentLink(e: any) {
		const index = this.supportingDocuments.findIndex(d => d.lookupId === e.row.data.lookupId);
		this.supportingDocuments.splice(index, 1);

		return false;
	}

	deleteWorkOrderLink(e: any) {
		this.purchaseLogWorkOrderService.deleteSingleById(e.row.data.id)
			.subscribe(
				() => {
					this.toastService.success("Successfully Removed Work Order");
					this.getWorkOrders();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);

		return false;
	}

	displayWorkOrderInDropdown(e: any) { 
		if (e === null || e === undefined) {
			return "";
		}

		const dateRequired = new Date(e.dateRequired);
		
		return "WO: " + e.id + " - PN: " + e.part.partNumber + " - DR: " + dateRequired.toDateString();
	}

	downloadFileLink(e: any) {
		const lookupId = Guid.parse(e.row.data.lookupId);
		this.fileService.downloadFile(lookupId).subscribe(
			(response: any) => {
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
				downloadLink.setAttribute("download", e.row.data.fileName);
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
		return false;
	}

	downloadPrice(line: any) {
		const data = line.row.data;
		// Required to calculate the line cost, set the material id and remove the auto generated __KEY__ property
		this.lineItems.find((item: any) => {
			if (item.__KEY__ === data.__KEY__) {
				// todo: maybe pull this from the contracts?
				/*if (this.item.purchaseType == 50) {
					const partNo = item.lineDescription.split(">");
					const thisPart: Part = this.partsSpec.filter(x => x.partNumber == partNo[0].trim())[0];
					const thisPartSpecs: PartOutsourcedSpecification[] = JSON.parse(thisPart.outsourcedSpecifications);
					const thisSpec: PartOutsourcedSpecification = thisPartSpecs.filter(x => x.description == partNo[1].trim())[0];
					item.cost = thisSpec.defaultPrice;
				}*/
				item.lineCost = item.cost * item.quantity;
				item.__KEY__ = undefined;

				if (item.lineNumber == null) {
					item.lineNumber = data.lineNumber;
				}
			}
		});

		this.item.totalCost = 0;
		this.lineItems.forEach(obj => {
			this.item.totalCost += obj.lineCost;
		});
	}

	duplicate() {
		if (confirm("Are you sure you wish to duplicate this purhcase log? This cannot be undone.") === false) {
			return;
		}
		this.itemService.duplicatePurchaseLog(this.item.id)
			.subscribe(
				(res: any) => {
					const duplicateItem = res.response;
					this.router.navigate([`${this.itemUrl}/${duplicateItem.lookupId}`]);
				},
				(err: any) => {
					this.toastService.error("Could not duplicate purchase log");
					console.log(err);
				}
			);
	}

	edit() {
		this.readOnly = false;
		this.buildButtons("edit");
		this.title = "Edit " + this.itemType;
		this.toastService.warn("You are now editing...");
	}

	filterParts(projectId: number) {
		if (projectId !== undefined && projectId > 0) {
			this.filteredParts = this.parts.filter((p) => p.projectId === projectId);
		}
		else {
			this.filteredParts = this.parts;
		}
	}

	filterPurchasableItems(purchaseType: PurchaseTypeEnum) {
		if (this.purchasableItems.length > 0) {
			if (purchaseType != PurchaseTypeEnum.Outsourced) {
				this.filteredPurchasableItems = this.purchasableItems.filter((pi) => pi.purchaseType === purchaseType);
			} else {
				this.filteredPurchasableItems = [];
				/*const i = 1;
				let tempSpecs: PartOutsourcedSpecification[] = [];
				tempSpecs = JSON.parse(this.partSelected.outsourcedSpecifications);
				tempSpecs.forEach((x) => {
					if (x.supplierId === this.item.supplierId) {
						const tempItem = new PurchasableItem();
						tempItem.id = i;
						tempItem.description = x.description + " - " + this.outsourcedSpecifications.find(os => os.id === x.outsourcedSpecificationId)?.specification;
						tempItem.minimumBuyableQuantity = 0;
						tempItem.purchaseType = PurchaseType.Outsourced;

						this.filteredPurchasableItems.push(tempItem);
					}
				});*/
			}
		}
	}

	formDataChanged(args: any) {
		switch (args.dataField) {
			case "purchaseType":
				this.filterPurchasableItems(args.value);
				break;
			case "projectId":
				this.filterParts(args.value);
				break;
			case "supplierId": {
				const selectedSupplier = this.suppliers.find(s => s.id === args.value);
				if (selectedSupplier && !selectedSupplier.approvedSupplier) {
					alert("This supplier has not been approved for use, please contact procurement or use a different supplier");
					this.item.supplierId = null as any;
					if (this.purchaseLogForm?.instance) {
						this.purchaseLogForm.instance.updateData("supplierId", null);
					}
					this.contacts = [];
					this.contracts = [];
					break;
				}
				this.getContacts(args.value);
				this.getContracts(args.value);
				this.getPurchasableSpecs(args.value);
				this.filterPurchasableItems(this.item.purchaseType);
				break;
			}
			case "supplierContactId":
				this.getContact(args.value);
				break;
		}
	}

	generatePDF() {
		this.itemService.generateAndEmailPdf(this.item.id)
			.subscribe(
				() => {
					this.toastService.success("PDF has been generated and emailed.");
				},
				(err: any) => console.log(err)
			);
	}

	generatePreviewPDF() {
		this.itemService.generateAndPreviewPdf(this.item.id).subscribe(
			(response: any) => {
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
				downloadLink.setAttribute("download", "Purchase_Order_" + this.item.id + ".pdf");
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
	}

	getClients() {
		this.clientService.getAll()
			.subscribe(
				(res: any) => {
					this.clients = res.response.items;
					this.clients.sort((a, b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	getContact(contactId: number) {
		this.supplierContactService.getSingleById(contactId)
			.subscribe(
				(res: any) => {
					this.contact = res.response;
					this.item.supplierContactId = contactId;
					this.item.contactEmail = res.response.contactEmailAddress;
					this.item.contactName = res.response.contactName;
				},
				(err) => console.log(err)
			);
	}

	getContacts(supplierId: number, setNewestContact = false) {
		this.supplierContactService.getContactsBySupplierId(supplierId)
			.subscribe(
				(res: any) => {
					this.contacts = res.response;

					if (setNewestContact) {
						this.getContact(this.contacts[this.contacts.length - 1].id);
					} else if (this.contacts.some(c => c.id === this.item.supplierContactId)) {
						// do nothing, the contact is present
					}
					else {
						this.getContact(this.contacts[0].id);
					}

					this.contacts.sort((a, b) => a.contactName.localeCompare(b.contactName));
				},
				(err) => console.log(err)
			);
	}

	getContracts(supplierId: number) {
		this.contractService.getBySupplierId(supplierId)
			.subscribe(
				(res: any) => {
					this.contracts = res.response;
					this.contracts.sort((a, b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	getEmail() {
		this.authService.getCurrentUserProfile()
			.subscribe(
				(res: any) => { this.item.email = res.response.user.email; },
				(err) => console.log(err)
			);
	}

	getItem(lookupId: Guid, mode: string) {
		this.itemService.getSingleByLookupId(lookupId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					this.lineItems = JSON.parse(this.item.lineItems);
					this.supportingDocuments = JSON.parse(this.item.supportingDocuments);
					this.getContacts(this.item.supplierId);
					this.getContracts(this.item.supplierId);
					this.getParts();
					this.getPurchasableItems();
					this.getWorkOrders();
					this.getLineItemAllocations();
					this.buildButtons(mode);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	getLineItemAllocations() {
		this.purchaseLogLineItemAllocationService.getByPurchaseLogId(this.item.id)
			.subscribe(
				(res: any) => {
					this.lineItemAllocations = res.response;
				},
				(err) => console.log(err)
			);
	}

	getParts() {
		this.partService.getAll()
			.subscribe(
				(res: any) => {
					this.parts = res.response.items;
					this.parts.sort((a, b) => a.partNumber.localeCompare(b.partNumber));

					if (this.item != null) {
						this.filterParts(this.item.projectId);
					}
				},
				(err) => console.log(err)
			);
	}

	getPaymentTerms() {
		this.paymentTermsService.getAll()
			.subscribe(
				(res: any) => {
					this.paymentTerms = res.response.items;
				},
				(err) => {console.log(err); this.toastService.error("Something Went Wrong!");}
			);
	}

	getProjects(setNewestProject = false) {
		this.projectService.getAll()
			.subscribe(
				(res: any) => {
					this.projects = res.response.items;
					if (setNewestProject) {
						this.item.projectId = this.projects[this.projects.length - 1].id;
					}

					this.projects.sort((a, b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	getPurchasableItems() {
		this.purchasableItemService.getAll()
			.subscribe(
				(res: any) => {
					this.purchasableItems = res.response.items;
					this.purchasableItems.sort((a, b) => a.name.localeCompare(b.name));

					if (this.item != null) {
						this.filterPurchasableItems(this.item.purchaseType);
					}
				},
				(err) => console.log(err)
			);
	}

	getPurchasableSpecs(id: number) {
		this.partService.purchaseSpecifications(id)
			.subscribe(
				(res: any) => {
					this.purchasableSpecs = res.response;
					this.purchasableSpecs.sort((a, b) => a.localeCompare(b));
				},
				(err) => console.log(err)
			);

		this.partService.getBySpecificationSupplier(id)
			.subscribe(
				(res: any) => {
					this.partsSpec = res.response;
				},
				(err) => console.log(err)
			);
	}

	getSites() {
		this.siteService.getAll()
			.subscribe(
				(res: any) => {
					this.sites = res.response.items;
					this.sites.sort((a, b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	getStores() {
		this.stockStoreService.getAllByLogId(this.item.id)
			.subscribe(
				(res: any) => {
					this.stockStore = res.response;
					this.clients.sort((a, b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	getSuppliers(setNewestSupplier = false) {
		this.supplierService.getAll()
			.subscribe(
				(res: any) => {
					this.suppliers = res.response.items;

					if (setNewestSupplier) {
						this.item.supplierId = this.suppliers[this.suppliers.length - 1].id;
					}

					this.suppliers.sort((a, b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	getWorkOrders() {
		this.purchaseLogWorkOrderService.forPurchaseLog(this.item.id)
			.subscribe(
				(res: any) => {
					this.workOrders = res.response;
					this.getStores();
				},
				(err) => console.log(err)
			);
	}

	getWorkOrdersForAllocationsDropDown(description: string) {
		const encodedDescription = encodeURIComponent(description);
		this.workOrderService.forPurchasableItemDescription(encodedDescription)
			.subscribe(
				(res: any) => {
					this.workOrdersDropDownForAllocations = res.response;
				},
				(err) => console.log(err)
			);
	}

	getWorkOrdersForDropDown() {
		this.workOrderService.getAll()
			.subscribe(
				(res: any) => {
					this.workOrdersDropDown = res.response.items;
					this.workOrdersDropDown.sort((a, b) => {
						return a.id - b.id;
					});
				},
				(err) => console.log(err)
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	isCreateAllocationAvailable(e: any) {
		return e.row.data.quantityAllocated === null || e.row.data.quantityAllocated === undefined || e.row.data.quantityAllocated < e.row.data.quantity;
	}

	markPaid() {
		if (confirm("Are you sure you wish to mark this Purchase Log as paid? This cannot be undone.") === false) {
			return;
		}
		this.itemService.markPaid(this.item.id)
			.subscribe(
				() => {
					this.getItem(this.item.lookupId, this.screenMode);
				},
				(err: any) => {
					this.toastService.error("Could not duplicate purchase log");
					console.log(err);
				}
			);
	}

	onInitNewLineItemRow(row: any) {
		if (this.item.purchaseType === PurchaseTypeEnum.BoughtOutParts) {
			row.data.lineDescription = ""; // todo: replace this with whatever BPL eventually decide on
		}
		row.data.lookupId = Guid.create().toString();
	}

	onSetLineItemDescriptionCellValue(newRowData: PurchaseLogLineItem, value: string) {
		newRowData.lineDescription = value;

		// Attempt to load the purchasable item to fetch its defined cost
		const purchasableItems: PurchasableItem[] = this.filteredPurchasableItems.length > 0 ? this.filteredPurchasableItems.filter(x => x.name == value) : this.purchasableItems.filter(x => x.name == value);
		if (purchasableItems.length > 0) {
			const purchasableItem = purchasableItems[0];

			if (purchasableItem.cost !== undefined && purchasableItem.cost !== null) {
				newRowData.cost = purchasableItem.cost;
			}
		}
	}

	popupPurchasableItemFormDataChanged(args: any) {
		switch (args.dataField) {
			case "purchaseType":
				if (this.popupPurchasableItem.purchaseType !== PurchaseTypeEnum.Material && this.popupPurchasableItem.purchaseType !== PurchaseTypeEnum.ToolingBillet) {
					this.popupPurchasableItem.materialType = MaterialType.NotApplicable;
				}
				this.popupPurchasableItem.weightConstant = densityForMaterialType(this.popupPurchasableItem.materialType);
				break;
			case "materialType":
				// Density (weightConstant) is derived from the material type.
				this.popupPurchasableItem.weightConstant = densityForMaterialType(this.popupPurchasableItem.materialType);
				break;
		}
	}

	saveLineItemChanges(line: any) {
		const data = line.row.data;

		if (data.lineNumber === undefined) {
			data.lineNumber = this.lineItems.length + 1;
		} else {
			this.updateLineNumbers();
		}
		this.dataGrid.instance.saveEditData();
		// Required to calculate the line cost, set the material id and remove the auto generated __KEY__ property
		this.lineItems.find((item: any) => {
			if (item.__KEY__ === data.__KEY__) {
				item.lineCost = item.cost * item.quantity;
				item.__KEY__ = undefined;

				if (item.lineNumber == null) {
					item.lineNumber = data.lineNumber;
				}
			}
		});

		this.item.totalCost = 0;
		this.lineItems.forEach(obj => {
			this.item.totalCost += obj.lineCost;
		});
	}

	stockReceived() {
		if (confirm("Are you sure? This will create a stock store for each line item and mark the Purchase Log as received. This cannot be undone. Please ensure there is a purchasable item set up for each line item first.") === false) {
			return;
		}
		this.stockStoreService.purchaseLogReceived(this.item.id)
			.subscribe(
				() => {
					this.toastService.success("Successfully Marked as Received");
					this.item.orderReceived = true;
					this.buildButtons(this.screenMode);
				},
				(err: any) => {
					console.log(err);
					this.toastService.error("Failed to Log item as received");
				},
			);
	}

	stockReceivedSingle(line: any) {
		if (confirm("Are you sure? This will create a stock store for this line item. This cannot be undone. Please ensure there is a purchasable item set up for this line item first.") === false) {
			return;
		}
		this.stockStoreService.purchaseLogLineItemReceived(this.item.id, line.row.data)
			.subscribe(
				() => { this.toastService.success("Successfully added to Stock Store"); },
				(err: any) => {
					console.log(err);
					this.toastService.error("Failed to Log item as received");
				},
			);
	}

	updateItem() {
		this.updateLineNumbers();
		this.item.lineItems = JSON.stringify(this.lineItems);
		this.item.supportingDocuments = JSON.stringify(this.supportingDocuments);

		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated");
					this.getItem(this.item.lookupId, this.screenMode);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	updateLineNumbers() {
		for (let i = 0; i < this.lineItems.length; i++) {
			this.lineItems[i].lineNumber = i + 1;
		}
	}

	uploadSupportingDocument(file: File) {
		const containerName = "purchaselogfiles";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", file);
		// Add Mime Type key when mime types are decided upon...
		// uploadData.append("mimeTypeKey", "CADFileMimeTypes");
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					this.popupSupportingDocument.lookupId = res.response[0].lookupId;
					this.popupSupportingDocument.fileName = res.response[0].name;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Supporting Document Upload Failed - Please ensure you are uploading a valid file");
				}
			);
	}

	viewLineItemAllocationWorkOrder(e: any) {
		this.router.navigate([`/admin/workOrders/${e.row.data.workOrderId}`]);
	}

	viewStoreItem(e: any) {
		this.router.navigate([`admin/stores/${e.row.data.id}`]);
	}

	viewWorkOrderLink(e: any) {
		this.router.navigate([`/admin/workOrders/${e.row.data.workOrderId}`]);
	}
}